export const FETCH_INITIAL_EXPERIENCES_AVAILABILITY =
  "experiencesAvailability/FETCH_INITIAL_EXPERIENCES_AVAILABILITY";
export type FETCH_INITIAL_EXPERIENCES_AVAILABILITY =
  typeof FETCH_INITIAL_EXPERIENCES_AVAILABILITY;

export const FETCH_FILTERED_EXPERIENCES_AVAILABILITY =
  "experiencesAvailability/FETCH_FILTERED_EXPERIENCES_AVAILABILITY";
export type FETCH_FILTERED_EXPERIENCES_AVAILABILITY =
  typeof FETCH_FILTERED_EXPERIENCES_AVAILABILITY;

export const FETCH_PRICE_FILTERED_EXPERIENCES_AVAILABILITY =
  "experiencesAvailability/FETCH_PRICE_FILTERED_EXPERIENCES_AVAILABILITY";
export type FETCH_PRICE_FILTERED_EXPERIENCES_AVAILABILITY =
  typeof FETCH_PRICE_FILTERED_EXPERIENCES_AVAILABILITY;

export const FETCH_MORE_EXPERIENCES_AVAILABILITY =
  "experiencesAvailability/FETCH_MORE_EXPERIENCES_AVAILABILITY";
export type FETCH_MORE_EXPERIENCES_AVAILABILITY =
  typeof FETCH_MORE_EXPERIENCES_AVAILABILITY;

export const FETCH_EXPERIENCES_AVAILABILITY_REQUEST_PARAMS =
  "experiencesAvailability/FETCH_EXPERIENCES_AVAILABILITY_REQUEST_PARAMS";
export type FETCH_EXPERIENCES_AVAILABILITY_REQUEST_PARAMS =
  typeof FETCH_EXPERIENCES_AVAILABILITY_REQUEST_PARAMS;

export const STOP_FETCH_MORE_EXPERIENCES_AVAILABILITY =
  "experiencesAvailability/STOP_FETCH_MORE_EXPERIENCES_AVAILABILITY";
export type STOP_FETCH_MORE_EXPERIENCES_AVAILABILITY =
  typeof STOP_FETCH_MORE_EXPERIENCES_AVAILABILITY;

export const SET_EXPERIENCES_AVAILABILITY_RESULTS =
  "experiencesAvailability/SET_EXPERIENCES_AVAILABILITY_RESULTS";
export type SET_EXPERIENCES_AVAILABILITY_RESULTS =
  typeof SET_EXPERIENCES_AVAILABILITY_RESULTS;

export const SET_EXPERIENCES_AVAILABILITY_CALL_STATE_FAILED =
  "experiencesAvailability/SET_EXPERIENCES_AVAILABILITY_CALL_STATE_FAILED";
export type SET_EXPERIENCES_AVAILABILITY_CALL_STATE_FAILED =
  typeof SET_EXPERIENCES_AVAILABILITY_CALL_STATE_FAILED;

export const SET_KEYWORD = "experiencesAvailability/SET_KEYWORD";
export type SET_KEYWORD = typeof SET_KEYWORD;

export const SET_FILTER_TRIPADVISOR_RATING =
  "experiencesAvailability/SET_FILTER_TRIPADVISOR_RATING";
export type SET_FILTER_TRIPADVISOR_RATING =
  typeof SET_FILTER_TRIPADVISOR_RATING;

export const SET_FILTER_START_TIMES =
  "experiencesAvailability/SET_FILTER_START_TIMES";
export type SET_FILTER_START_TIMES = typeof SET_FILTER_START_TIMES;

export const SET_FILTER_DURATION =
  "experiencesAvailability/SET_FILTER_DURATION";
export type SET_FILTER_DURATION = typeof SET_FILTER_DURATION;

export const SET_FILTER_PRICE = "experiencesAvailability/SET_FILTER_PRICE";
export type SET_FILTER_PRICE = typeof SET_FILTER_PRICE;

export const SET_FILTER_POPULAR_FEATURES =
  "experiencesAvailability/SET_FILTER_POPULAR_FEATURES";
export type SET_FILTER_POPULAR_FEATURES = typeof SET_FILTER_POPULAR_FEATURES;

export const SET_FILTER_TAGS = "experiencesAvailability/SET_FILTER_TAGS";
export type SET_FILTER_TAGS = typeof SET_FILTER_TAGS;

export const SET_SORT_OPTION = "experiencesAvailability/SET_SORT_OPTION";
export type SET_SORT_OPTION = typeof SET_SORT_OPTION;

export const RESET_FILTER_AND_SORT =
  "experiencesAvailability/RESET_FILTER_AND_SORT";
export type RESET_FILTER_AND_SORT = typeof RESET_FILTER_AND_SORT;

export const FETCH_EXPERIENCES_AVAILABILITY_AUTOCOMPLETE =
  "experiencesAvailability/FETCH_EXPERIENCES_AVAILABILITY_AUTOCOMPLETE";
export type FETCH_EXPERIENCES_AVAILABILITY_AUTOCOMPLETE =
  typeof FETCH_EXPERIENCES_AVAILABILITY_AUTOCOMPLETE;

export const SET_EXPERIENCES_AVAILABILITY_AUTOCOMPLETE_RESULTS =
  "experiencesAvailability/SET_EXPERIENCES_AVAILABILITY_AUTOCOMPLETE_RESULTS";
export type SET_EXPERIENCES_AVAILABILITY_AUTOCOMPLETE_RESULTS =
  typeof SET_EXPERIENCES_AVAILABILITY_AUTOCOMPLETE_RESULTS;

export const RESET_EXPERIENCES_AVAILABILITY =
  "experiencesAvailability/RESET_EXPERIENCES_AVAILABILITY";
export type RESET_EXPERIENCES_AVAILABILITY =
  typeof RESET_EXPERIENCES_AVAILABILITY;

export const SET_EXPERIENCE_TAG_COUNT =
  "experiencesAvailability/SET_EXPERIENCE_TAG_COUNT";
export type SET_EXPERIENCE_TAG_COUNT = typeof SET_EXPERIENCE_TAG_COUNT;

export const FETCH_BOOKED_ACTIVITIES =
  "experiencesSearch/FETCH_BOOKED_ACTIVITIES";
export type FETCH_BOOKED_ACTIVITIES = typeof FETCH_BOOKED_ACTIVITIES;

export const SET_USER_HAS_BOOKED_ACTIVITIES =
  "experiencesSearch/SET_USER_HAS_BOOKED_ACTIVITIES";
export type SET_USER_HAS_BOOKED_ACTIVITIES =
  typeof SET_USER_HAS_BOOKED_ACTIVITIES;

export const SET_VIEW_PREFERENCE =
  "experiencesAvailability/SET_VIEW_PREFERENCE";
export type SET_VIEW_PREFERENCE = typeof SET_VIEW_PREFERENCE;

export const FETCH_ATTRACTION = "experiencesAvailability/FETCH_ATTRACTION";
export type FETCH_ATTRACTION = typeof FETCH_ATTRACTION;

export const SET_SELECTED_ATTRACTION =
  "experiencesAvailability/SET_SELECTED_ATTRACTION";
export type SET_SELECTED_ATTRACTION = typeof SET_SELECTED_ATTRACTION;
